<template>
    <v-container fluid>
        <v-container fluid>
            <v-row class="py-0">
                <v-col cols="12" xl="6" class="title py-0">すべての書類</v-col>
            </v-row>
        </v-container>
        <v-expansion-panels v-model="panel" multiple class="px-3 ma-0">
            <v-expansion-panel>
                <v-expansion-panel-header class="search-title py-2 px-2">検索条件</v-expansion-panel-header>
                <v-expansion-panel-content class="px-4">
                    <v-container class="search-container pa-0">
                        <v-row no-gutters>
                            <div class="search-section my-1">
                                <div class="sear pr-5 my-1">
                                    <span class="search-status">
                                      状態: 
                                    </span>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.conclusion = searchItem.conclusion ? false : true" v-bind:class="{blur: searchItem.conclusion}">
                                      締結済み
                                    </v-btn>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.not_conclusion = searchItem.not_conclusion ? false : true" v-bind:class="{blur: searchItem.not_conclusion}">
                                      未締結
                                    </v-btn>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.import = searchItem.import ? false : true" v-bind:class="{blur: searchItem.import}">
                                      インポート
                                    </v-btn>
                                </div>
                                <div class="sear pr-5 my-1">
                                    <span class="search-status">
                                      種類: 
                                    </span>
                                    <v-btn text rounded class="mx-1 px-2 search-lable lightblue" @click="searchItem.is_confidential = searchItem.is_confidential ? false : true" v-bind:class="{blur: searchItem.is_confidential}">
                                      親展書類
                                    </v-btn>
                                </div>
                                <div class="sear pr-5 my-1">
                                    <span class="search-status">
                                      自動更新: 
                                    </span>
                                    <v-btn text rounded x-small class="mx-1 px-1 search-lable lightblue" @click="searchItem.automatic_updating_on = searchItem.automatic_updating_on ? false : true" v-bind:class="{blur: searchItem.automatic_updating_on}">
                                      有
                                    </v-btn>
                                    <v-btn text rounded x-small class="mx-1 px-1 search-lable lightblue" @click="searchItem.automatic_updating_off = searchItem.automatic_updating_off ? false : true" v-bind:class="{blur: searchItem.automatic_updating_off}">
                                      無
                                    </v-btn>
                                </div>
                                <div class="sear pr-5 my-1">
                                    <span class="search-status">
                                      アラート: 
                                    </span>
                                    <v-btn text rounded x-small class="mx-1 px-1 search-lable lightblue" @click="searchItem.alert_on = searchItem.alert_on ? false : true" v-bind:class="{blur: searchItem.alert_on}">
                                      有
                                    </v-btn>
                                    <v-btn text rounded x-small class="mx-1 px-1 search-lable lightblue" @click="searchItem.alert_off = searchItem.alert_off ? false : true" v-bind:class="{blur: searchItem.alert_off}">
                                      無
                                    </v-btn>
                                </div>
                            </div>
                        </v-row>
                        <v-row class="my-1" no-gutters>
                            <v-col xl="5" lg="5" md="5" sm="12" xs="12" class="pa-0 mr-8">
                                <badge-component tile color="unset">
                                    <label-component height="25" style="font-size: 13px">取引先</label-component>
                                </badge-component>
                                <select-component
                                    v-model="searchItem.to_contract_companies"
                                    :items="toContractCompanies"
                                ></select-component>
                            </v-col>
                            <v-col xl="2" lg="2" md="2" sm="5" xs="12" class="align-self-end pa-0">
                                <badge-component tile color="unset">
                                    <label-component height="25" style="font-size: 13px">取引金額</label-component>
                                </badge-component>
                                <text-field-component
                                    v-model="searchItem.amount_from"
                                ></text-field-component>
                            </v-col>
                            <div class="align-self-end pa-2" style="font-size: 13px">～</div>
                            <v-col xl="2" lg="2" md="2" sm="5" xs="12" class="align-self-end pa-0">
                                <text-field-component
                                    v-model="searchItem.amount_to"
                                ></text-field-component>
                            </v-col>
                        </v-row>
                        <v-row class="my-1" no-gutters>
                            <v-col xl="3" lg="3" md="3" sm="12" xs="12" class="py-0">
                                <badge-component tile color="unset">
                                    <label-component height="25" style="font-size: 13px">日付</label-component>
                                </badge-component>
                                <single-select-component
                                    v-model="searchItem.periodType"
                                    :items="periodTypes"
                                    item-text="name"
                                    item-value="type"
                                ></single-select-component>
                            </v-col>
                            <div class="align-self-end pa-2" style="font-size: 13px">-></div>
                            <v-col xl="2" lg="2" md="2" sm="5" xs="12" class="align-self-end pa-0">
                                <date-picker-mini-component v-model="searchItem.date_from" class="align-self-end"/>
                            </v-col>
                            <div class="align-self-end pa-2" style="font-size: 13px">～</div>
                            <v-col xl="2" lg="2" md="2" sm="5" xs="12" class="align-self-end pa-0">
                                <date-picker-mini-component v-model="searchItem.date_to" class="align-self-end"/>
                            </v-col>
                        </v-row>
                        <v-row class="py-0 my-1" no-gutters>
                            <v-col xl="5" md="5" sm="12" xs="12" class="py-0 mr-8">
                                <badge-component tile color="unset">
                                    <label-component height="25" style="font-size: 13px">フリーワード</label-component>
                                </badge-component>
                                <text-field-component
                                  v-model="searchItem.keyword" 
                                  placeholder="フリーワードを入力"
                                ></text-field-component>
                            </v-col>
                            <template v-if="user_defined_items.length > 0">
                                <v-col xl="3" lg="3" md="3" sm="5" xs="12" class="py-0">
                                    <badge-component tile color="unset">
                                        <label-component height="25" style="font-size: 13px">ユーザー定義項目</label-component>
                                    </badge-component>
                                    <single-select-component
                                        v-model="searchItem.user_defined_item"
                                        :items="user_defined_items"
                                        item-text="item_name"
                                        return-object
                                    ></single-select-component>
                                </v-col>
                                <div class="align-self-end pa-2" style="font-size: 13px">-></div>
                                <v-col xl="3" lg="3" md="3" sm="5" xs="12" class="align-self-end pa-0">
                                    <text-field-component
                                    v-model="searchItem.user_defined_item_value" 
                                    ></text-field-component>
                                </v-col>
                            </template>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>      
        <v-container fluid>
            <v-row>
                <v-col no-gutters class="page-offset-col">
                     <page_offset_limit_component :total="total" :items_per_page="indexInfo.itemsPerPage" :page="indexInfo.page" style="font-size: 12px;"></page_offset_limit_component>
                </v-col>
                <v-col class="align-self-end" offset-sm="0" offset-xs="0">
                    <v-pagination
                        v-model="indexInfo.page"
                        :length="indexInfo.pageCount"
                    ></v-pagination>
                </v-col>
                <v-col class="text-right" style="min-width: 250px;" no-gutters>
                    <v-btn @click="itemSettingDialog = true" color="blue" class="white--text setting-btn">表示設定</v-btn>
                    <VueJsonToCsv :json-data="csvData" :csv-title="csvTitle" :labels="filterLabels">
                        <v-btn @click="exportFiles" color="orange" class="white--text csv-btn">CSVエクスポート</v-btn>
                    </VueJsonToCsv>
                    <v-btn v-if="navi.plan == true && user.role == 1" color="green" class="white--text function-btn" href="/documents/document-management/import">書類インポート</v-btn>
                    <input id="fileUpload" type="file" @change="importCsv"  accept=".csv" hidden>
                    <v-btn @click="chooseFiles" color="green" class="white--text function-btn">書類情報インポート(CSV)</v-btn>
                </v-col>
            </v-row>
            <v-data-table
                loading-text="読込中"
                :items="filterItems"
                :headers="filterHeaders"
                :page.sync="indexInfo.page"
                :items-per-page="indexInfo.itemsPerPage"
                @page-count="indexInfo.pageCount = $event"
                hide-default-footer
                no-data-text="データなし"
                @click:row="itemAction"
            >
                <template v-slot:item.contract_name="{ item, value }">
                    <span v-if="item.agreement.is_confidential" style="border:1px solid red; border-radius: 2px; text-align: center; color: red; font-size: 11px;">親展</span>
                    {{ value }}
                </template> 
                <template v-slot:item.agreement.signature_method="{ value }">
                    {{ getSignatureMethodTextAbbreviation(value) }}
                </template> 
                <template v-slot:item.agreement.contract_status="{ value }">
                    <span v-bind:class="[value == '3' ? 'conclusion': value == '5' ? 'import' : 'not_conclusion']">
                        {{ getContractStatus(value) }}
                    </span>
                </template> 
                <template v-slot:item.agreement.updated_at="{ value }">
                    {{ weekTimeFormat(value) }}
                </template> 
                <template v-slot:item.conclusion_date="{ value }">
                    {{ getDateWithWeekText(value) }}
                </template> 
                <template v-slot:item.organization_names="{ value }">
                    {{ value.join('、') }}
                </template> 
                <template v-slot:item.to_company_names="{ value }">
                    {{ value.join('、') }}
                </template> 
                <template v-slot:item.contract_informations.contract_start_date="{ value }">
                    {{ getDateWithWeekText(value) }}
                </template> 
                <template v-slot:item.contract_informations.contract_end_date="{ value }">
                    {{ getDateWithWeekText(value) }}
                </template> 
                <template v-slot:item.contract_informations.cancellation_notice_deadline="{ value }">
                    {{ getDateWithWeekText(value) }}
                </template> 
                <template v-slot:item.contract_informations.contract_information_last_updated_datetime="{ value }">
                    {{ getDateWithWeekText(value) }}
                </template> 
                <template v-slot:item.contract_informations.is_automatic_updating="{ value }">
                    {{ getAutimaticUpdatingText(value) }}
                </template> 
                
                <template v-slot:item.contract_alerts="{ item }">
                    <template v-if="item.can_edit_alert">
                        <v-btn 
                            v-if="item.contract_alerts"
                            icon
                            class="white--text alert-btn"
                            color="orange"
                            @click.stop="edit(item)"
                        >
                            <v-icon>
                                {{ item.contract_alerts.alert_on_off == 1 ? "mdi-bell-ring" : "mdi-bell-off" }}
                            </v-icon>
                        </v-btn>
                        <v-btn 
                            v-else
                            class="white--text alert-btn"
                            color="orange"
                            @click.stop="edit(item)"
                        >
                            アラート設定
                        </v-btn>
                    </template>
                    <template v-else>
                        {{ item.contract_alerts && item.contract_alerts.alert_on_off == 1 ? '有' : '無' }}
                    </template>
                </template>
                <template v-slot:item.dot_menu="{ item }">
                    <all-document-dot-menu-component
                        :user="user"
                        :navi="navi"
                        :item="item"
                        @clickDelete="clickDotMenuDelete(item)"
                        @clickShare="clickDotMenuShare(item)"
                        @clickDeleteShare="clickDotMenuDeleteShare(item)"
                    >
                    </all-document-dot-menu-component>
                </template>
            </v-data-table>
        </v-container>
        <v-container>
            <all-document-display-item-setting v-model="itemSettingDialog" :itemSettingDialog="itemSettingDialog" :displaySetting="displaySetting" @parent-event="setDisplaySetting"></all-document-display-item-setting>
        </v-container>
        
        <!-- メッセージ -->
        <message-component id="message" v-model="showMessage" :success="message.success">{{ message.text }}</message-component>

        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>

        <alert-component 
            v-if="dialog.alert" 
            :dialog.sync="dialog.alert" 
            :item="alertItem" 
            @clickOk='setAlertData'
        />
        
        <!-- 削除確認ダイアログ -->
        <simple-dialog-component v-if="dialog.confirmDelete" :dialog.sync="dialog.confirmDelete" @clickOk="deleteItem(editItem)"
            :message="editItem.contract_name + 'を削除しますか？'" okBtn="削除" cancelbtn="キャンセル">
        </simple-dialog-component>
        
        <!-- キャビネットへ共有 登録ダイアログ -->
        <cabinet-folder-file-control-dialog-component v-if="dialog.share" :dialog.sync="dialog.share" :items="dialog.radioListItems" @pushOk="shareCabinet">
            <template v-slot>{{ dialog.shareOrMoveMessage }}</template>
            <template v-slot:btnName>共有</template>
        </cabinet-folder-file-control-dialog-component>
        
        <!-- キャビネットへ共有 削除ダイアログ -->
        <cabinet-folder-file-control-dialog-component v-if="dialog.shareDelete" :dialog.sync="dialog.shareDelete" :items="dialog.radioListItems" @pushOk="deleteShareCabine" okBtnColor="red">
            <template v-slot>{{ dialog.shareOrMoveMessage }}</template>
            <template v-slot:btnName>削除</template>
        </cabinet-folder-file-control-dialog-component>

        <!-- 書類情報インポート確認ダイアログ -->
        <simple-dialog-component v-if="dialog.confirmCsvImport" :dialog.sync="dialog.confirmCsvImport" @clickOk="saveCsvResult"
            :message="csvResult.length + '件の書類情報を読み込みました。インポートしますか？'" okBtn="OK" cancelbtn="キャンセル">
        </simple-dialog-component>
    </v-container>
</template>

<script>
    import moment from 'moment';
    import page_offset_limit_component from '../../components/common/PageOffsetLimitComponent.vue';
    import AllDocumentDisplayItemSetting from "./AllDocumentDisplayItemSetting";
    import AllDocumentDotMenuComponent from "./AllDocumentDotMenuComponent";
    import VueJsonToCsv from "vue-json-to-csv";
    import { parse } from 'csv-parse/sync';
    import { signatureMethodMixin } from '../../mixins/signatureMethodMixin.js';
    import { dateformatMixin } from '../../mixins/dateformatMixin.js';
    export default {
        props: {
            contracts: Array,
            user: Object,
            user_defined_items:Array,
            navi : [],
        },
        data() {
            let displaySetting = {
                'object_id' : false,
                'contract_name' : true,
                'agreement': {
                    'contract_name' : true,
                    'signature_method' : false,
                    'contract_status' : true,
                    'updated_at' : true,
                },
                'to_company_names' : true,
                'sender_name' : true,
                'organization_names' : true,
                'conclusion_date' : true,
                'contract_informations' : {
                    'control_number' : true,
                    'control_title' : true,
                    'transaction_amount' : true,
                    'memo' : true,
                    'contract_start_date' : true,
                    'contract_end_date' : true,
                    'is_automatic_updating' : true,
                    'cancellation_notice_deadline' : true,
                    'contract_information_last_updated_datetime' : true,
                },
                'user_defined_items' : [],
                'contract_alerts' : true,
            };
            return {
                panel: [0, 1],
                total:0,
                indexInfo: {
                    page: 1, // ページ数
                    pageCount: 0, // 最大ページ数
                    itemsPerPage: 10, // 1ページあたりの項目数
                },
                items: [],
                csvData: [],
                item_name_keys:[],
                alertItem: {
                    item: null,
                    contract_alerts_id: null,
                    agreements_or_folders_id: null,
                    alert_datetime: null,
                    note: null,
                    alert_type: 0,
                    alert_on_off: 0,
                    end_date: null,
                    cancel_notice_deadline: null
                },
                searchItem: {
                    conclusion: true,
                    not_conclusion: true,
                    import: true,
                    is_confidential: false,
                    automatic_updating_on: true,
                    automatic_updating_off: true,
                    alert_on: true,
                    alert_off: true,
                    periodType: "",
                    to_contract_companies: [],
                    keyword: "",
                    keyword: "",
                    amount_from: "",
                    amount_to: "",
                    date_from: "",
                    date_to: "",
                    user_defined_item: null,
                    user_defined_item_value: "",
                },
                toContractCompanies:[],
                periodTypes:[
                    { type:"conclusion_date", name:"契約締結日" },
                    { type:"contract_start_date", name:"契約開始日" },
                    { type:"contract_end_date", name:"契約終了日" },
                    { type:"cancellation_notice_deadline", name:"解約通知期限" },
                ],
                displaySetting: displaySetting,
                itemSettingDialog: false,
                editItem: null,
                message: {
                    success: false,
                    text: "",
                },
                dialog: {
                    alert: false,
                    share: false,
                    shareDelete: false,
                    shareOrMoveMessage: null,
                    confirmDelete: false,
                    radioListItems: null,
                    confirmCsvImport: false,
                },
                csvResult: [],
                sending: false,
            }
        },
        created() {
            let displaySetting = JSON.parse(window.localStorage.getItem('all_document_display_setting'));
            if (displaySetting){
                this.displaySetting = Object.assign(this.displaySetting, displaySetting);
            }

            this.displaySetting.user_defined_items = []
            if (this.user_defined_items){
                this.user_defined_items.forEach((item) => {
                    let value = true;
                    if (displaySetting){
                        let udi = displaySetting.user_defined_items.find(udi => udi.id == item.id);
                        if (udi){
                            value = udi.value;
                        }
                    }
                    this.displaySetting.user_defined_items.push({
                        id: item.id,
                        value: value,
                        item_name: item.item_name,
                    });
                });
            }

            let searchItem = JSON.parse(window.localStorage.getItem('all_document_search_item'));
            if (searchItem){
                this.searchItem = Object.assign(this.searchItem, searchItem);
            }

            let toContractCompanies = new Array;
            this.contracts.forEach(contract => {
                if(contract.to_company_names){
                    toContractCompanies = [...toContractCompanies, ...contract.to_company_names];
                }
                if(contract.contract_informations && contract.contract_informations.memo){
                    toContractCompanies.push(contract.contract_informations.memo);
                }                
            });
            if (toContractCompanies){
                this.toContractCompanies = Array.from(new Set(toContractCompanies));
            }

            this.items = this.contracts.map(contract => {
                if(contract.contract_user_defined_items && contract.contract_user_defined_items.length > 0){
                    this.user_defined_items.forEach((item_def, index) => {
                        let item = contract.contract_user_defined_items.find(item => item.user_defined_item_id === item_def.id);
                        var str = '{"user_defined_item_' + item_def.id + '":"' + (item?.value ?? '') + '"}';
                        var obj = JSON.parse(str);
                        contract = Object.assign(contract, obj);
                    });
                }

                let datetime = null;
                if (contract.agreement.conclusion_date){
                    datetime = contract.agreement.conclusion_date;
                }
                if (contract.contract_informations && contract.contract_informations.contract_date){
                    datetime = contract.contract_informations.contract_date;
                }
                if (datetime){
                    contract.conclusion_date = datetime;
                }

                return contract;
            });

        },
        computed: {
            csvTitle() {
                return "dxsign_doc_all_list";
            },
            filterHeaders(){
                let headers = new Array;
                if (this.displaySetting.contract_informations.control_number){
                    headers.push({
                        text: "管理番号",
                        value:'contract_informations.control_number',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_informations.control_title){
                    headers.push({
                        text: "管理タイトル",
                        value:'contract_informations.control_title',
                        sortable: true,
                    });
                }
                if (this.displaySetting.object_id){
                    headers.push({
                        text: "契約書ID",
                        value:'object_id',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_name){
                    headers.push({
                        text: "契約書名",
                        value:'contract_name',
                        sortable: true,
                    });
                }
                if (this.displaySetting.agreement.contract_name){
                    headers.push({
                        text: "件名",
                        value:'agreement.contract_name',
                        sortable: true,
                    });
                }
                if (this.displaySetting.agreement.contract_status){
                    headers.push({
                        text: "状態",
                        value:'agreement.contract_status',
                        sortable: true,
                    });
                }
                if (this.displaySetting.agreement.signature_method){
                    headers.push({
                        text: "署名方式",
                        value:'agreement.signature_method',
                        sortable: true,
                    });
                }
                if (this.displaySetting.agreement.updated_at){
                    headers.push({
                        text: "更新/登録日時",
                        value:'agreement.updated_at',
                        sortable: true,
                    });
                }
                if (this.displaySetting.conclusion_date){
                    headers.push({
                        text: "契約締結日",
                        value:'conclusion_date',
                        sortable: true,
                    });
                }
                if (this.displaySetting.to_company_names){
                    headers.push({
                        text: "契約先",
                        value:'to_company_names',
                        sortable: true,
                    });
                }
                if (this.displaySetting.sender_name){
                    headers.push({
                        text: "送信者/登録者",
                        value:'sender_name',
                        sortable: true,
                    });
                }
                if (this.displaySetting.organization_names){
                    headers.push({
                        text: "共有グループ",
                        value:'organization_names',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_informations.transaction_amount){
                    headers.push({
                        text: "取引金額",
                        value:'contract_informations.transaction_amount',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_informations.memo){
                    headers.push({
                        text: "取引先",
                        value:'contract_informations.memo',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_informations.contract_start_date){
                    headers.push({
                        text: "契約開始日",
                        value:'contract_informations.contract_start_date',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_informations.contract_end_date){
                    headers.push({
                        text: "契約終了日",
                        value:'contract_informations.contract_end_date',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_informations.cancellation_notice_deadline){
                    headers.push({
                        text: "解約通知期限",
                        value:'contract_informations.cancellation_notice_deadline',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_informations.is_automatic_updating){
                    headers.push({
                        text: "自動更新の有無",
                        value:'contract_informations.is_automatic_updating',
                        sortable: true,
                        align: "center",
                    });
                }

                if (this.user_defined_items){
                    this.user_defined_items.forEach((item) => {
                        let udi = this.displaySetting.user_defined_items.find(udi => udi.id === item.id);
                        if (udi && udi.value){
                            headers.push({
                                text: item.item_name,
                                value:'user_defined_item_' + item.id,
                                sortable: true,
                            });
                        }
                    });
                }
                if (this.displaySetting.contract_informations.contract_information_last_updated_datetime){
                    headers.push({
                        text: "契約情報更新日時",
                        value:'contract_informations.contract_information_last_updated_datetime',
                        sortable: true,
                    });
                }
                if (this.displaySetting.contract_alerts){
                    headers.push({
                        text: "アラート",
                        value:'contract_alerts',
                        sortable: false,
                        align: "center",
                    });
                }
                headers.push({
                        text: "",
                        value:'dot_menu',
                        sortable: false,
                        align: "center",
                    });
                
                return headers;
            },
            filterItems(){
                let searchItem = this.searchItem;
                let checked = false;
                let items = this.items.filter(function(item) {
                    if (!item) {
                        return false;
                    }
                    if(searchItem.conclusion || searchItem.not_conclusion || searchItem.import){
                        checked = false;
                        if (item.agreement.contract_status == '3'){
                            if(searchItem.conclusion){
                                checked = true;
                            }
                        } else if (item.agreement.contract_status == '5'){
                            if(searchItem.import){
                                checked = true;
                            }
                        } else {
                            if(searchItem.not_conclusion){
                                checked = true;
                            }
                        }

                        if(!checked){
                            return checked;
                        }
                    }

                    if(searchItem.is_confidential){
                        checked = false;
                        if (item.agreement.is_confidential){
                            checked = true;
                        }

                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if (searchItem.automatic_updating_on || searchItem.automatic_updating_off){
                        checked = false;
                        if (item.contract_informations && item.contract_informations.is_automatic_updating){
                            if (searchItem.automatic_updating_on){
                                checked = true;
                            }
                        }else{
                            if (searchItem.automatic_updating_off){
                                checked = true;
                            }
                        }

                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if (searchItem.alert_on || searchItem.alert_off){
                        checked = false;
                        if (item.contract_alerts && item.contract_alerts.alert_on_off == 1 ){
                            if (searchItem.alert_on){
                                checked = true;
                            }
                        }else{
                            if (searchItem.alert_off){
                                checked = true;
                            }
                        }

                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if(searchItem.to_contract_companies.length > 0){
                        checked = false;
                        searchItem.to_contract_companies.forEach((to_contract_company) => {
                            if(item.to_company_names.indexOf(to_contract_company) !== -1){
                                checked = true;
                            }
                            if(item.contract_informations && item.contract_informations.memo == to_contract_company){
                                checked = true;
                            }
                        });
                        
                        if(!checked){
                            return checked;
                        }
                    }
                    if(searchItem.periodType && (searchItem.date_from || searchItem.date_to)){
                        checked = false;
                        
                        let datetime = null;
                        if (searchItem.periodType == "conclusion_date"){
                            if (item.conclusion_date){
                                datetime = new Date(item.conclusion_date);
                            }
                        }
                        if (searchItem.periodType == "contract_start_date"){
                            if (item.contract_informations && item.contract_informations.contract_start_date){
                                datetime = new Date(item.contract_informations.contract_start_date);
                            }
                        }
                        if (searchItem.periodType == "contract_end_date"){
                            if (item.contract_informations && item.contract_informations.contract_end_date){
                                datetime = new Date(item.contract_informations.contract_end_date);
                            }
                        }
                        if (searchItem.periodType == "cancellation_notice_deadline"){
                            if (item.contract_informations && item.contract_informations.cancellation_notice_deadline){
                                datetime = new Date(item.contract_informations.cancellation_notice_deadline);
                            }
                        }

                        if (datetime){
                            datetime = new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate());
                            
                            if (searchItem.date_from && searchItem.date_to){
                                let date_from = new Date(searchItem.date_from);
                                let date_to = new Date(searchItem.date_to);
                                date_from = new Date(date_from.getFullYear(), date_from.getMonth(), date_from.getDate());
                                date_to = new Date(date_to.getFullYear(), date_to.getMonth(), date_to.getDate());
                                
                                if (datetime >= date_from && datetime <= date_to){
                                    checked = true;
                                }
                            }else if (searchItem.date_from){
                                let date_from = new Date(searchItem.date_from);
                                date_from = new Date(date_from.getFullYear(), date_from.getMonth(), date_from.getDate());
                                if (datetime >= date_from){
                                    checked = true;
                                }
                            }else if (searchItem.date_to){
                                let date_to = new Date(searchItem.date_to);
                                date_to = new Date(date_to.getFullYear(), date_to.getMonth(), date_to.getDate());
                                if (datetime <= date_to){
                                    checked = true;
                                }
                            }
                        }

                        if(!checked){
                            return checked;
                        }
                    }

                    if(searchItem.amount_from || searchItem.amount_to){
                        checked = false;
                        
                        let amount = null;
                        if (item.contract_informations && item.contract_informations.transaction_amount){
                            amount = Number(item.contract_informations.transaction_amount);
                        }

                        if (amount){
                            if (searchItem.amount_from && searchItem.amount_to){
                                let amount_from = Number(searchItem.amount_from);
                                let amount_to = Number(searchItem.amount_to);
                                if (amount >= amount_from && amount <= amount_to){
                                    checked = true;
                                }
                            }else if (searchItem.amount_from){
                                let amount_from = Number(searchItem.amount_from);
                                if (amount >= amount_from){
                                    checked = true;
                                }
                            }else if (searchItem.amount_to){
                                let amount_to = Number(searchItem.amount_to);
                                if (amount <= amount_to){
                                    checked = true;
                                }
                            }
                        }

                        if(!checked){
                            return checked;
                        }
                    }
                    
                    if(searchItem.keyword){
                        let splitedKeyword = searchItem.keyword.split(/ |　/g);
                        checked = splitedKeyword.every(keyword => {
                            if(item.contract_name.indexOf(keyword) !== -1) {
                                return true;
                            }
                            if(item.object_id.indexOf(keyword) !== -1) {
                                return true;
                            }
                            if(item.agreement.contract_name.indexOf(keyword) !== -1) {
                                return true;
                            }
                            if((item.contract_informations?.control_number?.indexOf(keyword) ?? -1) !== -1) {
                                return true;
                            }
                            if((item.contract_informations?.control_title?.indexOf(keyword) ?? -1) !== -1) {
                                return true;
                            }
                            if(item.to_company_names?.some(to_company_name => to_company_name.indexOf(keyword) !== -1)){
                                return true;
                            }
                            if((item.contract_informations?.memo?.indexOf(keyword) ?? -1) !== -1){
                                return true;
                            }
                            if(item.sender_name.indexOf(keyword) !== -1) {
                                return true;
                            }
                            if(item.organization_names?.some(organization_name => organization_name.indexOf(keyword) !== -1)){
                                return true;
                            }

                            return false;
                        });
                        if(!checked){
                            return checked;
                        }
                    }

                    if(searchItem.user_defined_item && searchItem.user_defined_item_value){
                        checked = false;
                        
                        if (item.contract_user_defined_items){
                            let udi = item.contract_user_defined_items.find(udi => udi.user_defined_item_id === searchItem.user_defined_item.id);
                            if (udi && udi.value){
                                let splitedKeyword = searchItem.user_defined_item_value.split(/ |　/g);
                                checked = splitedKeyword.every(keyword => {
                                    if(udi.value.indexOf(keyword) !== -1) {
                                        return true;
                                    }
                                    return false;
                                });
                            }
                        }

                        if(!checked){
                            return checked;
                        }
                    }

                    return true;
                });
                
                window.localStorage.setItem('all_document_search_item', JSON.stringify(searchItem));

                this.total = items.length;
                return items;
            },
            filterLabels(){
                let labels = new Object();
                labels.control_number = { title: "管理番号" };
                labels.control_title = { title: "管理タイトル" };
                labels.contract_object_id = { title: "契約書ID" };
                labels.contract_name = { title: "契約書名" };
                labels.agreement_contract_name = { title: "件名" };
                labels.contract_status = { title: "状態" };
                labels.signature_method = { title: "署名方式" };
                labels.is_import = { title: "インポート" };
                labels.updated_at = { title: "更新/登録日時" };                
                labels.conclusion_date = { title: "契約締結日" };
                labels.conclusion_company = { title: "契約先" };
                labels.sender_name = { title: "送信者/登録者" };
                labels.share_group = { title: "共有グループ" };
                labels.transaction_amount = { title: "取引金額" };
                labels.memo = { title: "取引先" };
                labels.contract_date = { title: "契約締結日" };
                labels.contract_start_date = { title: "契約開始日" };
                labels.contract_end_date = { title: "契約終了日" };
                labels.cancellation_notice_deadline = { title: "解約通知期限" };
                labels.is_automatic_updating = { title: "自動更新の有無" };
                if(this.user_defined_items){
                    this.user_defined_items.forEach((item, index) => {
                        let key = "item_name_" + item.id;
                        labels[key] = { title: item.item_name };
                        this.item_name_keys.push(key);
                    });
                }
                labels.contract_information_last_updated_datetime = { title: "契約情報更新日時" };
                labels.alert_datetime = { title: "アラート日" };
                labels.alert_on_off = { title: "アラートOnOff" };
                labels.alert_memo = { title: "アラートメモ" };
                
                return labels;
            },

            showMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        methods: {
            itemAction(item) {
                // 書類クリック時
                window.location.href = "/documents/document-management/view/" + item.object_id;
            },
            exportFiles() {
                let regExp = /"/g;
                this.csvData = [];
                this.items.forEach((contract) => {
                    let contents = new Object();
                    let control_number = contract.contract_informations ? contract.contract_informations.control_number : "";
                    let control_title = contract.contract_informations ? contract.contract_informations.control_title : "";
                    let transaction_amount = contract.contract_informations ? contract.contract_informations.transaction_amount : "";
                    let memo = contract.contract_informations ? contract.contract_informations.memo : "";
                    let is_automatic_updating = this.getAutimaticUpdatingText(contract.contract_informations?.is_automatic_updating);
                    let updated_at = this.weekTimeFormat(contract.agreement.updated_at);
                    let signature_method = this.getSignatureMethodText(contract.agreement.signature_method);
                    let contract_status = this.getContractStatus(contract.agreement.contract_status);
                    let conclusion_date = this.weekTimeFormat(contract.conclusion_date);
                    let import_date = contract.agreement.is_uploaded_contract ? this.weekTimeFormat(contract.agreement.created_at) : "";
                    let contract_date = contract.contract_informations ? this.getDateFormat(contract.contract_informations.contract_date) : "";
                    let contract_start_date = contract.contract_informations ? this.getDateFormat(contract.contract_informations.contract_start_date) : "";
                    let contract_end_date = contract.contract_informations ? this.getDateFormat(contract.contract_informations.contract_end_date) : "";
                    let cancellation_notice_deadline = contract.contract_informations ? this.getDateFormat(contract.contract_informations.cancellation_notice_deadline) : ""; 
                    let last_updated_datetime =  contract.contract_informations ? this.weekTimeFormat(contract.contract_informations.contract_information_last_updated_datetime) : ""; 
                    let alert_datetime = contract.contract_alerts ? this.weekTimeFormat(contract.contract_alerts.alert_datetime) : "";

                    contents.control_number = control_number ? control_number.replace(regExp, '""') : "";
                    contents.control_title = control_title ? control_title.replace(regExp, '""') : "";
                    contents.contract_object_id = contract.object_id;
                    contents.contract_name = contract.contract_name ? contract.contract_name.replace(regExp, '""') : "";
                    contents.agreement_contract_name = contract.agreement.contract_name ? contract.agreement.contract_name.replace(regExp, '""') : "";
                    contents.signature_method = signature_method;
                    contents.is_import = contract.agreement.is_uploaded_contract;
                    contents.updated_at = updated_at;
                    contents.contract_status = contract_status;
                    contents.conclusion_date = conclusion_date;
                    contents.import_date = import_date;
                    contents.conclusion_company = contract.to_company_names.join('、');
                    contents.sender_name = contract.sender_name;
                    contents.share_group = contract.organization_names.join('、');
                    contents.transaction_amount = transaction_amount ?? "";
                    contents.memo = memo ? memo.replace(regExp, '""') : "";
                    contents.contract_date = contract_date;
                    contents.contract_start_date = contract_start_date;
                    contents.contract_end_date = contract_end_date;
                    contents.is_automatic_updating = is_automatic_updating;
                    contents.cancellation_notice_deadline = cancellation_notice_deadline;
                    contents.contract_information_last_updated_datetime = last_updated_datetime;
                    if(this.item_name_keys.length > 0){
                        this.item_name_keys.forEach((key) => {
                             contents[key] = "";
                        });
                    }
                    if(contract.contract_user_defined_items && contract.contract_user_defined_items.length > 0){
                        contract.contract_user_defined_items.forEach((item) => {
                            contents["item_name_" + item.user_defined_item_id] = item.value ? item.value : "";
                        });
                    }
                    contents.alert_datetime = alert_datetime;
                    contents.alert_on_off = contract.contract_alerts?.alert_on_off ?? '';
                    contents.alert_memo = contract.contract_alerts?.note?.replace(regExp, '""') ?? "";
                    
                    this.csvData.push(contents);
                });
            },
            chooseFiles: function() {
                document.getElementById("fileUpload").click();
            },
            // CSVファイル読み込む
            importCsv: async function(e) {
                var self = this;
                let file = e.target.files[0] || e.dataTransfer.files[0];
                var header = Object.values(this.filterLabels).map(item => item.title);
                var headerKeys = Object.keys(this.filterLabels);

                let reader = new FileReader();
                reader.readAsText (file, 'utf-8');
                await new Promise(resolve => reader.onload = () => resolve());

                const records = parse(reader.result);
                let arrHeader = records[0];
                if(JSON.stringify(arrHeader) != JSON.stringify(header)){
                    self.message.text = "正しい宛先CSVファイルを選択してください"+JSON.stringify(arrHeader) + JSON.stringify(header);
                    return;
                }
                let csvResult = records.filter(item => item.some(item => item)).map(item => {
                    let _str = { 'user_defined_items': [] };
                    item.forEach((v, i) => {
                        let result = /^item_name_([0-9]+)$/.exec(headerKeys[i]);
                        if (result){
                            let udi_id = result[1];
                            _str['user_defined_items'].push({
                                'user_defined_item_id' : udi_id,
                                'value': v.trim(),
                            });
                        } else {
                            _str[headerKeys[i]] = v.trim();
                        }
                    });
                    return _str;
                });

                csvResult.shift()
                // リセット
                document.getElementById("fileUpload").value = "";

                this.csvResult = csvResult;
                this.dialog.confirmCsvImport = true;

            },
            async saveCsvResult(){
                try {
                    this.sending = true;

                    let inputs = this.csvResult.map(item => {
                        let _item = { 'contract_information': {}, 'user_defined_items': [] };
                        _item.contract_object_id = item.contract_object_id;
                        _item.contract_information.control_number = item.control_number;
                        _item.contract_information.control_title = item.control_title;
                        _item.contract_information.transaction_amount = item.transaction_amount;
                        _item.contract_information.memo = item.memo;
                        if (item.is_automatic_updating == "有"){
                            _item.contract_information.is_automatic_updating = 2;
                        } else if (item.is_automatic_updating == "無"){
                            _item.contract_information.is_automatic_updating = 1;
                        } else if (!item.is_automatic_updating){
                            _item.contract_information.is_automatic_updating = 0;
                        } else {
                            _item.contract_information.is_automatic_updating = item.is_automatic_updating;
                        }
                        _item.contract_information.contract_date = item.contract_date;
                        _item.contract_information.contract_start_date = item.contract_start_date;
                        _item.contract_information.contract_end_date = item.contract_end_date;
                        _item.contract_information.cancellation_notice_deadline = item.cancellation_notice_deadline;
                        _item.user_defined_items = item.user_defined_items;

                        return _item;
                    });

                    var self = this;
                    await axios.post(
                        '/documents/document-management/all-document/contract-informations',
                        {
                            'inputs': inputs,
                        }
                    )
                    .then(function (response) {
                        if (response.data.success) {
                            var url = location.href;
                            window.location = url;
                        }else{
                            self.message.success = false;
                            self.message.text = response.data.message;
                        }
                        self.sending = false;
                    }).catch(function (response) {
                        self.message.success = false;
                        self.message.text = 'インポート処理に失敗しました。件数を減らして再度お試しください。';
                    });

                }finally{
                    this.sending = false;
                }
            },            
            getContractStatus(contractStatus){
                if (contractStatus == '3'){
                    return '締結済み';
                }else if (contractStatus == '5'){
                    return 'インポート';
                }else{
                    return '未締結';
                }
            },
            setDisplaySetting(displaySetting){
                this.displaySetting = displaySetting;
            },            
            edit(item) {
                this.alertItem = {
                    item: item,
                    contract_alerts_id: (item.contract_alerts?.id)?? null,
                    agreements_or_folders_id: item.contract_id,
                    alert_datetime: (item.contract_alerts?.alert_datetime)?? null,
                    note: (item.contract_alerts?.note)?? null,
                    alert_type: (item.contract_alerts?.alert_type)?? null,
                    alert_on_off: (item.contract_alerts?.alert_on_off)?? null,
                    end_date: (this.getDateFormat(item.contract_informations?.contract_end_date))?? null,
                    cancel_notice_deadline: (this.getDateFormat(item.contract_informations?.cancellation_notice_deadline))?? null
                };
                this.dialog.alert = true;
            },
            setAlertData(...args) {
                const [contractAlertsId, contractId, alertDateTime, note, type, onOff] = args;
                this.alertItem.item.contract_id = contractId;
                if(alertDateTime == null) {
                    this.alertItem.item.contract_alerts = null;
                } else {
                    this.alertItem.item.contract_alerts = {
                        id: contractAlertsId,
                        alert_datetime: alertDateTime,
                        note: note,
                        alert_type: type,
                        alert_on_off: onOff
                    };
                }
            },
            // ドットメニューの削除クリック時
            clickDotMenuDelete(item) {
                this.dialog.confirmDelete = true;
                this.editItem = item;
            },
            // ドットメニューの共有 登録クリック時
            clickDotMenuShare(item) {
                this.editItem = item;
                axios.get('/documents/document-management/get-cabinet-list',{
                        params: {
                            name: item.contract_name,
                            agreements_or_folders_id: null,
                            is_delete: false,
                        }
                    }).then(res => {
                        this.dialog.share = true;
                        this.dialog.shareOrMoveMessage = res.data.message;
                        this.dialog.radioListItems = res.data.folders;
                });
            },
            // ドットメニューの共有 削除クリック時
            clickDotMenuDeleteShare(item) {
                this.editItem = item;
                axios.get('/documents/document-management/get-cabinet-list',{
                        params: {
                            name: item.contract_name,
                            agreements_or_folders_id: item.contract_id,
                            is_delete: true,
                        }
                    }).then(res => {
                        this.dialog.shareDelete = true;
                        this.dialog.shareOrMoveMessage = res.data.message;
                        this.dialog.radioListItems = res.data.folders;
                });
            },
            // 削除
            deleteItem(item) {
                axios.post('/documents/document-management/delete/' + item.contract_id ,{
                    name: item.contract_name,
                    isFolder: false,
                    isCabinet: false,
                    parentFolderId: null,
                    isUploadedContract: item.agreement.is_uploaded_contract
                }).then(res => {
                    if (res.data.success) {
                        // 一覧から削除
                        let index = this.items.indexOf(item);
                        this.items.splice(index, 1);
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            // キャビネットへ共有
            shareCabinet(cabinetId) {
                axios.post('/documents/document-management/share-contract/' + cabinetId ,{
                    contract_id : this.editItem.contract_id,
                }).then(res => {
                   if (res.data.success) {
                        this.message.text = res.data.message;
                        this.message.success = true;
                        axios.get('/documents/document-management/get-member-share-organizations' ,{
                            params: {
                                folderId: cabinetId,
                            }
                        }).then(res => {
                            this.editItem.organization_names = Array.from(new Set([...this.editItem.organization_names, ...res.data.allowed_organis.map(x => x.name)]));
                        });
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            // キャビネットの共有から削除
            deleteShareCabine(cabinetId) {
              axios.post('/documents/document-management/delete-share-cabinet/' + cabinetId ,{
                    contract_id : this.editItem.contract_id,
                }).then(res => {
                    if (res.data.success) {
                        this.message.text = res.data.message;
                        this.message.success = true;
                        axios.get('/documents/document-management/all-document/' + this.editItem.contract_id ,{
                        }).then(res => {
                            this.editItem.organization_names = res.data.contract.organization_names;
                        });
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            getAutimaticUpdatingText(is_automatic_updating){
                if (is_automatic_updating == 2) {
                    return "有";
                }else if(is_automatic_updating == 1) {
                    return "無";
                }else{
                    return "";
                }
            },
        },
        mixins:[
            signatureMethodMixin,
            dateformatMixin,
        ],
        components: {
            VueJsonToCsv,
            page_offset_limit_component,
            AllDocumentDisplayItemSetting,
            AllDocumentDotMenuComponent,
        },
    }
</script>
<style scoped lang="scss">
.title{
    font-size: 1.5rem !important;
    font-weight: bold;
}
.white-space-nowrap{
    max-width: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.search-container{
    max-width: 100%!important;
}

.search-title{
    font-size: 13px !important;
}
.search-section ::v-deep .v-btn{
    height: 26px !important;
}

.search-section ::v-deep .v-btn.lightblue{
    background-color: white !important;
    border-color: white !important;
}

.search-section ::v-deep .v-btn:hover{
    background-color: #78bcf3!important;
    border-color: #78bcf3!important;
    color:white;
}
.search-section ::v-deep .v-btn.blur{
    background-color: #2196f3!important;
    border-color: #2196f3!important;
    color:white;
}
.search-section .sear{
    display:inline-table;
}

::v-deep .v-expansion-panels {
    width: 99% !important;
}

::v-deep .v-expansion-panel-header__icon{
    margin-left: inherit !important;
}

::v-deep .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: 0px !important;
}

::v-deep .v-expansion-panel-content__wrap {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
.search-section ::v-deep .v-btn__content{
    font-size: 13px !important;
}
.search-status{
    font-weight: bold;
    font-size: 13px;
}



::v-deep .v-data-table-header > tr > th{
    white-space: pre;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 1.2rem !important;
    padding-left: 8px;
    padding-right: 8px;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 1.2rem !important;
    padding-left: 8px;
    padding-right: 8px;
    height: 40px;
}
::v-deep .page-offset-col{
    padding-top: 32px;
}
::v-deep .v-pagination__navigation{
    height: 25px !important;
    width: 25px !important;
}
::v-deep .v-pagination__item{
    height: 25px !important;
    width: 25px !important;
    min-width: 25px !important;
    font-size: 1.2rem !important;
}
::v-deep .function-btn.v-btn{
    height: 25px !important;
}
::v-deep .function-btn > .v-btn__content {
    font-size: 13px !important;
}
::v-deep .setting-btn.v-btn{
    height: 25px !important;
}
::v-deep .setting-btn > .v-btn__content {
    font-size: 13px !important;
}
::v-deep .csv-btn.v-btn{
    height: 25px !important;
}
::v-deep .csv-btn > .v-btn__content {
    font-size: 13px !important;
}

::v-deep .alert-btn.v-btn {
    height: 28px !important;
}

::v-deep .alert-btn > .v-btn__content {
    font-size: 1.5rem !important;
}

::v-deep .alert-btn > .v-btn__content .v-icon {
    font-size: 20px !important;
}

.conclusion{
    background-color: #7CB342;
    border-radius: 16px;
    width: 80px;
    display: block;
    text-align: center;
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
}
.not_conclusion{
    background-color: #FFB300;
    border-radius: 16px;
    width: 80px;
    display: block;
    text-align: center;
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
}
.import{
    background-color: #039BE5;
    border-radius: 16px;
    width: 80px;
    display: block;
    text-align: center;
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
}
</style>
